// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"143":"dafd6f34","186":"12112456","239":"c45f63c0","388":"3b53416f","507":"a416f8fc","588":"07aa124e","788":"438e1fbd","960":"b709c365"}[chunkId] + ".js";
};